import React from "react";
import { cn } from "../../lib/utils";

export default function CustomButton({
  textButton,
  roundness = "2xl",
  secondary = false,
  fullWidth = false,
  blueVariant = false,
  modalVariant = false,
  ...rest
}) {
  const roundedClass = `rounded-${roundness}`;

  if (blueVariant) {
    return (
      <button
        {...rest}
        className={cn(
          "py-3 px-4 lg:py-5 lg:px-8 bg-main-color justify-center items-center gap-5 inline-flex hover:opacity-70 transition-all duration-150 ease-linear",
          roundedClass
        )}
        aria-label={textButton}
      >
        <div className="text-center text-white text-md lg:text-2xl font-bold font-['Roboto'] leading-loose whitespace-nowrap">
          {textButton}
        </div>
      </button>
    );
  }

  if (!secondary) {
    return (
      <button
        {...rest}
        className={cn(
          "h-12 px-5 py-2 bg-white border-2 border-[#002198] flex-col justify-center items-center gap-2.5 inline-flex hover:opacity-70 transition-all duration-150 ease-linear",
          roundedClass
        )}
        aria-label={textButton}
      >
        <div className="justify-start items-center gap-[55px] inline-flex">
          <div className="justify-start items-center gap-2.5 flex">
            <div className="text-[#002198] text-lg font-normal font-['Roboto'] whitespace-nowrap">
              {textButton}
            </div>
          </div>
        </div>
      </button>
    );
  }

  if (modalVariant) {
    return (
      <button
        {...rest}
        className={cn(
          "text-main-color bg-white hover:border-opacity-20 focus:ring-0 focus:outline-none font-medium border border-main-color px-5 py-3 text-center flex items-center justify-center shadow-md min-w-[130px]",
          fullWidth ? "w-full" : "w-auto",
          roundedClass
        )}
        aria-label={textButton}
      >
        <div className="justify-start items-center gap-[55px] inline-flex">
          <div className="justify-start items-center gap-2.5 flex">
            <div className="text-white text-lg font-normal font-['Roboto'] whitespace-nowrap">
              {textButton}
            </div>
          </div>
        </div>
      </button>
    );
  }

  return (
    <button
      {...rest}
      className={cn(
        "h-12 px-5 py-2 border-2 border-white flex-col justify-center items-center gap-2.5 inline-flex hover:opacity-70 transition-all duration-150 ease-linear",
        roundedClass
      )}
      aria-label={textButton}
    >
      <div className="justify-start items-center gap-[55px] inline-flex">
        <div className="justify-start items-center gap-2.5 flex">
          <div className="text-white text-lg font-normal font-['Roboto'] whitespace-nowrap">
            {textButton}
          </div>
        </div>
      </div>
    </button>
  );
}
